<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <!-- <v-toolbar-title style="font-size:1rem;">设备信息</v-toolbar-title> -->
      <v-toolbar-title style="font-size:1rem;width:90%;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">设备信息 - {{companyInfo.COMPANY_NAME}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list style="padding:0;">
          <v-list-item @click="goCreateOrder" class="us-list-item">
            <v-list-item-title class="us-list-item-title">
              <i class="fa fa-plus-square" />
              <span>新建报障单</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding:0;">
        <div v-if="loading" style="margin-top:10rem;"><LoadingText /></div>
        <div v-else>
          <div><DeviceStateCard :dev-info="devInfo" /></div>
          <div v-if="devErrorInfo.length > 0">
            <DeviceErrorMessage :iot-id="iotId" :error-info="devErrorInfo" :server-time="errServerTime" />
          </div>
          <div style="padding:0.9rem 1.1rem 5rem;">
            <div style="position:relative;">
              <div style="position:absolute;left:-0.25rem;top:0;width:4.5rem;height:4.5rem;">
                <DeviceIconImage :dev-info="devInfo" :size="72"  />
              </div>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0;">
                  <!-- 当前状态 -->
                </v-col>
                <v-col :cols="9" style="padding-bottom:0.6rem;">
                  <DeviceStateText :dev-info="devInfo" />
                  <!-- <span v-if="activated" style="padding-left:0.5rem;padding-right:0.3rem;font-size:0.75rem;">( {{$moment(devInfo.ACTION_TIME).from()}}</span>
                  <span v-if="activated" style="font-size:0.75rem;">{{$moment(devInfo.ACTION_TIME).format("MM月DD日 HH:mm:ss")}} )</span> -->
                  <DeviceStateIcon v-if="!devInfo.offLine && devInfo.ACTION_TIME" :normal="normal" />
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  <!-- 设备名称 -->
                </v-col>
                <v-col :cols="9" style="padding-top:0px;padding-bottom: 0px;">
                  {{devInfo.DEV_TEXT}}
                </v-col>
              </v-row>
              <v-row v-if="systemTag">
                <v-col :cols="3" style="color:#9e9e9e;padding:0">
                  <!-- 系统标签 -->
                </v-col>
                <v-col :cols="9" style="padding:0px;">
                  <v-chip class="ma-2" label small outlined style="color:#9E9E9E">
                    {{systemTag}}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">地址：</v-col>
                <v-col :cols="9" style="word-break:break-all;">{{propInfo.pr_host_url}}</v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">状态：</v-col>
                <v-col :cols="9" >{{propInfo.pr_host_status_code}}</v-col>
              </v-row>
            </div>
            <div v-if="showMoreProp">
              <!-- <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  ID
                </v-col>
                <v-col :cols="9">
                  {{propInfo.IOT_ID}}
                </v-col>
              </v-row> -->
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  检查间隔
                </v-col>
                <v-col :cols="9">
                  {{propInfo.pr_span_time_s}} 秒
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  活跃时间
                </v-col>
                <v-col :cols="9" v-if="activated">
                  <!-- {{$moment(devInfo.ACTION_TIME).format("YYYY-MM-DD HH:mm:ss")}} -->
                  <span style="padding-right:0.3rem;" v-if="devInfoFormatTime">( {{devInfoFormatTime}} )</span>
                  <span>{{$moment(devInfo.ACTION_TIME).format("YYYY-MM-DD HH:mm:ss")}}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  主机名称
                </v-col>
                <v-col :cols="9">
                  {{devInfo.GW_DEV_TEXT}}
                </v-col>
              </v-row>
            </div>
            <div style="color:#9e9e9e;font-size:0.8rem;text-align:center;margin-top:0.5rem;">
              <span @click="showMoreProp=!showMoreProp">
                <span>查看更多</span>
                <i class="fa fa-angle-down" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" v-if="!showMoreProp"></i>
                <i class="fa fa-angle-up" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" v-else></i>
              </span>
            </div>
            <v-divider style="margin:1rem 0;" />
            <div>
              <div style="padding-bottom:0.3rem;color:#9e9e9e;">
                <v-icon color="warning" style="font-size:1.05rem;margin-right:0.3rem;">fa-volume-down</v-icon>告警记录
              </div>
              <AlertHistory :iot-id="iotId" />
            </div>
            <!-- <v-divider style="margin:1rem 0;" />
            <div>
              <v-list>
                <v-list-item class="us_list_item" @click="goStateHistory">
                  <v-list-item-content style="padding:0.55rem 0;">
                    <v-list-item-title>
                      <v-row style="width:100%;margin:0;font-size:0.9rem;padding-top:0.056rem;">
                        <span style="padding:0;color:#424242">查看状态历史</span>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon style="margin-left:1rem;">
                    <v-icon color="grey">fa fa-angle-right</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </div> -->
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
import DeviceStateText from './components/DeviceStateText'
import DeviceIconImage from './components/DeviceIconImage'
import DeviceStateCard from './components/DeviceStateCard'
import AlertHistory from './components/AlertHistory'
import DeviceErrorMessage from './components/DeviceErrorMessage'
import DeviceStateIcon from './components/DeviceStateIcon'
export default {
  components: { LoadingText, DeviceStateText, DeviceIconImage, DeviceStateCard, AlertHistory, DeviceErrorMessage, DeviceStateIcon },
  props: {},
  data() {
    return {
      iotId: '',
      propInfo: {},
      devInfo: {},
      showMoreProp: false,
      companyInfo: {},
      activated: true,
      loading: true,
      onlineHistVis: false,
      normal: false,
      devErrorInfo: [],
      systemTag: '',
      tagPrefix: 'yqyw@',
      devInfoFormatTime: '',
      errServerTime: ''
    }
  },
  computed: {
  },
  async mounted() {
    var that = this
    that.iotId = that.$route.query.iot_id
    await that.getDevice()
    await that.getDevProp()
    that.loading = false
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    // 获取设备信息
    async getDevice() {
      var that = this
      await that.$api.iot.getDevice({ iot_id: that.iotId }).then(res => {
        // console.log('getDevice.res', res);
        if (!res.success) {
          // that.$toast.warning('获取设备信息失败')
          console.log('获取设备信息失败', res);
          return
        }
        var data = res.data
        that.devInfoFormatTime = that.getDevInfoFormatTime(data.device.ACTION_TIME, res.time)
        that.devInfo = data.device
        that.companyInfo = data.company
        that.activated = that.devInfo.CUR_SID !== '0' && that.devInfo.CUR_SID !== 0
        that.normal = data.normal
        that.getDeviceSystemTags(that.devInfo.DEV_TAGS)
        // 离线退出
        if (data.device.offLine) {
          that.devErrorInfo = []
          return
        }
        that.getDeviceErrorMessage()
      })
    },
    // 获取设备属性
    async getDevProp() {
      var that = this
      var res = await that.$api.iot.getDeviceProp({ iot_id: that.iotId })
      // console.log('getDeviceProp.res', res);
      if (!res.success) {
        // that.$toast.warning('获取设备属性失败')
        console.log('获取设备属性失败', res);
        return
      }
      that.propInfo = res.data
      if (that.propInfo.pr_ip) {
        that.propInfo.pr_host = that.propInfo.pr_ip
      }
    },
    // 获取设备错误信息
    async getDeviceErrorMessage() {
      var that = this
      var res = await that.$api.iot.getDeviceErrorInfo({ iot_id: that.iotId })
      // console.log(res)
      if (!res.success) {
        console.log('获取设备错误信息失败', res)
        return
      }
      that.errServerTime = res.time
      that.devErrorInfo = that.judgeObjectIsNull(res.data) ? [] : res.data.items
    },
    // 跳转页面-设备状态历史
    goStateHistory() {
      var that = this
      that.$router.goPage({ path: '/DeviceStateHistory', query: { iot_id: that.iotId }})
    },
    // 判断对象是否为空
    judgeObjectIsNull(v) {
      if (!v) {
        return true
      }
      if (!v.items) {
        return true
      }
      return (JSON.stringify(v) === '{}' || JSON.stringify(v.items) === '{}')
    },
    // 跳转页面-创建报障工单
    goCreateOrder() {
      var that = this
      that.$router.goPage({
        path: '/CreateOrder',
        query:
        {
          title: '[' + that.devInfo.DEV_TEXT + ']异常',
          content: that.$Common.jointContent(that.devErrorInfo)
        }
      })
    },
    getDeviceSystemTags(tags) {
      if (tags === '' || !tags) {
        return []
      }
      var that = this
      var taglist = tags.split(';')
      for (let i = 0; i < taglist.length; i++) {
        if (taglist[i].startsWith(that.tagPrefix)) {
          that.systemTag = taglist[i].replace(that.tagPrefix, '')
          break
        }
      }
      return
    },
    getDevInfoFormatTime(dataTime, nowTime) {
      var that = this
      if (dataTime && nowTime) {
        return that.$moment(dataTime).from(nowTime)
      } else if (dataTime) {
        return that.$moment(dataTime).from()
      } else {
        return ''
      }
    }

  }
}
</script>

<style scoped>
</style>
